<template>
  <slot></slot>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'
import usePrintMode from '@canvas-builder/composables/usePrintMode'
import useCanvas from '@canvas-builder/composables/useCanvas'

const props = defineProps<{
  usedInSectionId: string
  sectionIdx: number
  sectionListId: string
  printModeIdx?: number
}>()

const { isPrintDisplayMode } = useCanvas()
const { getNextPrintModeIndex } = usePrintMode()

// Determine the correct print mode index immediately during setup
// Since print mode doesn't change, we can resolve this once
const printIndex =
  isPrintDisplayMode.value && props.printModeIdx === undefined
    ? getNextPrintModeIndex(props.sectionListId)
    : props.sectionIdx

const sectionInfo = computed(() => ({
  usedInSectionId: props.usedInSectionId,
  sectionIdx: props.sectionIdx,
  sectionListId: props.sectionListId,
  printModeIdx: isPrintDisplayMode.value ? (props.printModeIdx ?? printIndex) : props.sectionIdx,
}))

provide('sectionListSectionInfo', sectionInfo)
</script>
